import { migrateAssessmentTenantIdStorage } from "@sg-protect/core";
import { TenantProvider, useTenants } from "@sg-protect/shell";
import { type PropsWithChildren, useMemo } from "react";
import { useForbiddenTenantRedirect } from "#hooks/useForbiddenTenantRedirect.ts";

export function WorkspaceTenantProvider({ children }: PropsWithChildren) {
    const tenantId = useTenants().tenants?.migrateAssessmentTenants[0]?.id ?? null;
    const tenants = useMemo(() => (tenantId ? [{ tenantId }] : []), [tenantId]);
    const isRedirectInstalled = useForbiddenTenantRedirect();

    return (
        <TenantProvider key={tenantId} tenants={tenants} storage={migrateAssessmentTenantIdStorage}>
            {isRedirectInstalled ? children : null}
        </TenantProvider>
    );
}
